
function getCartSectionIds() {
  return [...document.querySelectorAll("[cart-section-id]")].map((el) => el.getAttribute("cart-section-id"));
}

function dispatchCartUpdate(cart, data) {
  document.dispatchEvent(
    new CustomEvent("updateCart", {
      detail: { cart, data },
    }),
  );

  document.dispatchEvent(
    new CustomEvent("cart:updated", {
      detail: { cartData: cart },
    }),
  );
}

function postCart(url, body, options, isError) {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...body, sections: getCartSectionIds().join() }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (isError(response)) {
        if (options?.onError) {
          options.onError(response);
        }

        return;
      }

      dispatchCartUpdate(response, options.data);

      if (options?.onAfterAdd) {
        options.onAfterAdd(response);
      }
    })
    .catch((error) => {
      console.error(error);

      if (options?.onError) {
        options.onError();
      }
    });
}

window.changeCart = (change, options = {}) =>
  postCart("/cart/change.js", change, options, (response) => response.status === 422 || response.status === 409);

window.updateCart = (updates, options = {}) =>
  postCart(
    "/cart/update.js",
    updates,
    options,
    (response) => response.status === 422 && response.message === "Cart Error",
  );

window.updateCartAttributes = (attributes, options = {}) =>
  postCart("/cart/update.js", { attributes }, options, (response) => response.status === 422);

window.addToCart = (items, options = {}) => {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }

  const normalizedItems = Array.isArray(items) ? items : [items];

  const data = {
    items: normalizedItems,
    sections: getCartSectionIds().join(),
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then(async (response) => {
      const body = await response.json();

      if (!response.ok) {
        if (options?.onError) {
          options.onError(body);
        }

        return null;
      }

      return body;
    })
    .then((response) => {
      if (!response) return;

      const sections = response.sections;

      return fetch("/cart.js", {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((cartResponse) => cartResponse.json())
        .then((cart) => {
          dispatchCartUpdate({ ...cart, sections }, options.data);

          if (options?.onAfterAdd) {
            options.onAfterAdd(response);
          }
        });
    })
    .catch((error) => {
      console.error("Unexpected add-to-cart error:", error);

      if (options?.onError) {
        options.onError({
          message: error instanceof Error ? error.message : "An unexpected cart error occurred.",
        });
      }
    });
};
